import { cn as _cn, isIframe as _isIframe } from "../lib/utils";

// Corporate pages are mounted under /corporate, so all internal links are prefixed.
export function createPageUrl(pageName) {
  return "/corporate/" + String(pageName).replace(/ /g, "-");
}

export const cn = _cn;
export const isIframe = _isIframe;
